module.exports = __webpack_public_path__ + "img/about.cf93e2c2.jpg";